import { render, staticRenderFns } from "./KidsClubEventList.vue?vue&type=template&id=2585bc42&scoped=true&"
import script from "./KidsClubEventList.vue?vue&type=script&lang=js&"
export * from "./KidsClubEventList.vue?vue&type=script&lang=js&"
import style0 from "./KidsClubEventList.vue?vue&type=style&index=0&id=2585bc42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585bc42",
  null
  
)

export default component.exports